module.exports = function(ngModule) {
    require('./alertService')(ngModule);
    require('./siteVisit.api')(ngModule);
};
